module.exports = __webpack_public_path__ + "media/articles/generic-article-thumbnail_200x133-da4f1cc1.png";